import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import ConsoleHelper from 'src/shared/functions/consoleHelper';
import { useIsMounted } from 'src/shared/hooks/useIsMounted';
import { getAllTitles } from 'src/shared/services/titleService';
import { TitlePickerItem } from '../models/titlePickerItem';

// Hämtar alla uppdrag (titlar) en gång och bygger picker-items. Används för att både gömma
// hela Uppdrag-sektionen när inga uppdrag finns och mata pickern med samma data (en enda fetch).
export const useMemberTitles = () => {
  const { t } = useTranslation(['member']);
  const isMounted = useIsMounted();
  const [titles, setTitles] = useState<TitlePickerItem[]>([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    (async () => {
      try {
        const result = await getAllTitles(null);
        if (isMounted()) {
          const titleArray: TitlePickerItem[] = [];
          result.data.results
            .sort((a, b) => (a.type > b.type ? 0 : -1))
            .forEach((item) => {
              titleArray.push({
                code: item.title_id,
                parentName: item.type === 0 ? t('member:memberAdvancedSearch.boardTitle') : t('member:memberAdvancedSearch.electedTitle'),
                parentCode: item.title_id,
                isParent: false,
                name: item.title,
              });
            });
          setTitles(titleArray);
        }
      } catch (e) {
        if (isMounted()) ConsoleHelper.log(e);
      } finally {
        if (isMounted()) setLoading(false);
      }
    })();
  }, [isMounted, t]);

  return { titles, loading };
};
